import React from "react";
import { Box, Typography } from "@mui/material";

// Import all available AWS service icons from PNG files
import SNSIcon from "./../../../assets/images/aws/SNS.png";
import RDSIcon from "./../../../assets/images/aws/RDS.png";
import DynamoDBIcon from "./../../../assets/images/aws/DynamoDB.png";
import LambdaIcon from "./../../../assets/images/aws/lambda.png";
import ACMIcon from "./../../../assets/images/aws/ACM.png";
import GuardDutyIcon from "./../../../assets/images/aws/GuardDuty.png";
import IAMIcon from "./../../../assets/images/aws/IAM.png";
import ELBIcon from "./../../../assets/images/aws/ELB.png";
import ECSIcon from "./../../../assets/images/aws/ECS.png";
import EC2Icon from "./../../../assets/images/aws/EC2.png";
import CloudTrailIcon from "./../../../assets/images/aws/CloudTrail.png";
import CloudWatchIcon from "./../../../assets/images/aws/CloudWatch.png";
import APIGatewayIcon from "./../../../assets/images/aws/APIGateway.png";
import CloudFrontIcon from "./../../../assets/images/aws/CloudFront.png";
import VPCIcon from "./../../../assets/images/aws/VPC.png";
import S3Icon from "./../../../assets/images/aws/S3.png";
import Route53Icon from "./../../../assets/images/aws/Route53.png";
import KMSIcon from "./../../../assets/images/aws/KMS.png";
import SQSIcon from "./../../../assets/images/aws/SQS.png";
import ECRIcon from "./../../../assets/images/aws/ECR.png";
import SecretManagerIcon from "./../../../assets/images/aws/SecretManager.png";
import EventBridgeIcon from "./../../../assets/images/aws/EventBridge.png";
import SystemsManagerIcon from "./../../../assets/images/aws/SystemsManager.png";
import CloudFormationIcon from "./../../../assets/images/aws/aws-cloudformation.png";
import WAFIcon from "./../../../assets/images/aws/WAF.png";
import EFSIcon from "./../../../assets/images/aws/EFS.png";
import EKSIcon from "./../../../assets/images/aws/EKS.png";
import AutoScalingIcon from "./../../../assets/images/aws/AutoScaling.png";
import BackupIcon from "./../../../assets/images/aws/Backup.png";
import SecurityHubIcon from "./../../../assets/images/aws/Arch_AWS-Security-Hub_48.png";
import WellArchitectedIcon from "./../../../assets/images/aws/AWS-Well-Architected-Tool.png";

// Import icons from react-aws-icons library for missing services
import AppStreamIcon from "react-aws-icons/dist/aws/logo/AppStream";
import AthenaIcon from "react-aws-icons/dist/aws/logo/Athena";
import BatchIcon from "react-aws-icons/dist/aws/logo/Batch";
import ConnectIcon from "react-aws-icons/dist/aws/logo/Connect";
import DataPipelineIcon from "react-aws-icons/dist/aws/logo/DataPipeline";
import DeviceFarmIcon from "react-aws-icons/dist/aws/logo/DeviceFarm";
import DMSIcon from "react-aws-icons/dist/aws/logo/DMS";
import DirectoryServiceIcon from "react-aws-icons/dist/aws/logo/DirectoryService";
import DynamoDBAcceleratorIcon from "react-aws-icons/dist/aws/logo/DynamoDBAccelerator";
import ElasticCacheIcon from "react-aws-icons/dist/aws/logo/ElasticCache";
import GameListIcon from "react-aws-icons/dist/aws/logo/GameList";
import GlueIcon from "react-aws-icons/dist/aws/logo/Glue";
import LexIcon from "react-aws-icons/dist/aws/logo/Lex";
import QuickSightIcon from "react-aws-icons/dist/aws/logo/QuickSight";
import RedshiftIcon from "react-aws-icons/dist/aws/logo/Redshift";
import SESIcon from "react-aws-icons/dist/aws/logo/SES";
import StepFunctionsIcon from "react-aws-icons/dist/aws/logo/StepFunctions";
import XRayIcon from "react-aws-icons/dist/aws/logo/XRay";

// Additional icons from react-aws-icons
import CodeBuildIcon from "react-aws-icons/dist/aws/logo/CodeBuild";
import CodeCommitIcon from "react-aws-icons/dist/aws/logo/CodeCommit";
import CodeDeployIcon from "react-aws-icons/dist/aws/logo/CodeDeploy";
import CodePipelineIcon from "react-aws-icons/dist/aws/logo/CodePipeline";
import CognitoIcon from "react-aws-icons/dist/aws/logo/Cognito";
import EMRIcon from "react-aws-icons/dist/aws/logo/EMR";
import ESIcon from "react-aws-icons/dist/aws/logo/ES";
import InspectorIcon from "react-aws-icons/dist/aws/logo/Inspector";
import KinesisIcon from "react-aws-icons/dist/aws/logo/Kinesis";
import ServiceCatalogIcon from "react-aws-icons/dist/aws/logo/ServiceCatalog";
import StorageGatewayIcon from "react-aws-icons/dist/aws/logo/StorageGateway";

// Additional icons for more services
import ApplicationDiscoveryServiceIcon from "react-aws-icons/dist/aws/logo/ApplicationDiscoveryService";
import ChimeIcon from "react-aws-icons/dist/aws/logo/Chime";
import CloudDirectoryIcon from "react-aws-icons/dist/aws/logo/CloudDirectory";
import CloudHSMIcon from "react-aws-icons/dist/aws/logo/CloudHSM";
import CloudSearchIcon from "react-aws-icons/dist/aws/logo/CloudSearch";
import CodeStarIcon from "react-aws-icons/dist/aws/logo/CodeStar";
import ConfigIcon from "react-aws-icons/dist/aws/logo/Config";
import DirectConnectIcon from "react-aws-icons/dist/aws/logo/DirectConnect";
import ElasticBeanstalkIcon from "react-aws-icons/dist/aws/logo/ElasticBeanstalk";
import ElasticTranscoderIcon from "react-aws-icons/dist/aws/logo/ElasticTranscoder";
import GlacierIcon from "react-aws-icons/dist/aws/logo/Glacier";
import GreengrassIcon from "react-aws-icons/dist/aws/logo/Greengrass";
import IoTIcon from "react-aws-icons/dist/aws/logo/IoT";
import LightsailIcon from "react-aws-icons/dist/aws/logo/Lightsail";
import MachineLearningIcon from "react-aws-icons/dist/aws/logo/MachineLearning";
import MacieIcon from "react-aws-icons/dist/aws/logo/Macie";
import ManagedServicesIcon from "react-aws-icons/dist/aws/logo/ManagedServices";
import MechanicalTurkIcon from "react-aws-icons/dist/aws/logo/MechanicalTurk";
import MigrationHubIcon from "react-aws-icons/dist/aws/logo/MigrationHub";
import MobileAnalyticsIcon from "react-aws-icons/dist/aws/logo/MobileAnalytics";
import MobileHubIcon from "react-aws-icons/dist/aws/logo/MobileHub";
import OpsWorksIcon from "react-aws-icons/dist/aws/logo/OpsWorks";
import OrganizationsIcon from "react-aws-icons/dist/aws/logo/Organizations";
import PinpointIcon from "react-aws-icons/dist/aws/logo/Pinpoint";
import PollyIcon from "react-aws-icons/dist/aws/logo/Polly";
import RekognitionIcon from "react-aws-icons/dist/aws/logo/Rekognition";
import ShieldIcon from "react-aws-icons/dist/aws/logo/Shield";
import SMSIcon from "react-aws-icons/dist/aws/logo/SMS";
import SnowballIcon from "react-aws-icons/dist/aws/logo/Snowball";
import SWFIcon from "react-aws-icons/dist/aws/logo/SWF";
import TrustedAdvisorIcon from "react-aws-icons/dist/aws/logo/TrustedAdvisor";

// Default AWS icon for unmapped services
import DefaultAWSIcon from "./../../../assets/images/compliance/aws.svg";

// Comprehensive mapping of AWS service names to icons
// This handles the actual API response keys
export const resourceIconMap = {
  // Services with PNG icons (your existing icons)
  "s3": S3Icon,
  "ec2": EC2Icon,
  "iam": IAMIcon,
  "ecs": ECSIcon,
  "kms": KMSIcon,
  "rds": RDSIcon,
  "sns": SNSIcon,
  "sqs": SQSIcon,
  "ecr": ECRIcon,
  "vpc": VPCIcon,
  "acm": ACMIcon,
  "waf": WAFIcon,
  "efs": EFSIcon,
  "eks": EKSIcon,
  "elasticloadbalancing": ELBIcon,
  "elbv2": ELBIcon,
  "lambda": LambdaIcon,
  "cloudtrail": CloudTrailIcon,
  "cloudwatch": CloudWatchIcon,
  "cloudfront": CloudFrontIcon,
  "route53": Route53Icon,
  "dynamodb": DynamoDBIcon,
  "apigateway": APIGatewayIcon,
  "cloudformation": CloudFormationIcon,
  "eventbridge": EventBridgeIcon,
  "guardduty": GuardDutyIcon,
  "ssm": SystemsManagerIcon,
  "secretsmanager": SecretManagerIcon,
  "autoscaling": AutoScalingIcon,
  "backup": BackupIcon,
  "securityhub": SecurityHubIcon,
  "wellarchitected": WellArchitectedIcon,
  
  // Services with react-aws-icons
  "appstream": AppStreamIcon,
  "athena": AthenaIcon,
  "batch": BatchIcon,
  "connect": ConnectIcon,
  "datapipeline": DataPipelineIcon,
  "devicefarm": DeviceFarmIcon,
  "dms": DMSIcon,
  "ds": DirectoryServiceIcon,
  "dax": DynamoDBAcceleratorIcon,
  "elasticache": ElasticCacheIcon,
  "gamelift": GameListIcon,
  "glue": GlueIcon,
  "lex": LexIcon,
  "quicksight": QuickSightIcon,
  "redshift": RedshiftIcon,
  "ses": SESIcon,
  "states": StepFunctionsIcon,
  "xray": XRayIcon,
  
  // Additional services with react-aws-icons
  "codebuild": CodeBuildIcon,
  "codecommit": CodeCommitIcon,
  "codedeploy": CodeDeployIcon,
  "codepipeline": CodePipelineIcon,
  "cognito-idp": CognitoIcon,
  "cognito-identity": CognitoIcon,
  "emr": EMRIcon,
  "es": ESIcon,
  "inspector": InspectorIcon,
  "kinesis": KinesisIcon,
  "servicecatalog": ServiceCatalogIcon,
  "storagegateway": StorageGatewayIcon,
  
  // Additional services with react-aws-icons
  "servicediscovery": ApplicationDiscoveryServiceIcon,
  "chime": ChimeIcon,
  "clouddirectory": CloudDirectoryIcon,
  "cloudhsm": CloudHSMIcon,
  "cloudsearch": CloudSearchIcon,
  "codestar": CodeStarIcon,
  "config": ConfigIcon,
  "directconnect": DirectConnectIcon,
  "elasticbeanstalk": ElasticBeanstalkIcon,
  "elastictranscoder": ElasticTranscoderIcon,
  "glacier": GlacierIcon,
  "greengrass": GreengrassIcon,
  "iot": IoTIcon,
  "lightsail": LightsailIcon,
  "machinelearning": MachineLearningIcon,
  "macie": MacieIcon,
  "managedservices": ManagedServicesIcon,
  "mechanicalturk": MechanicalTurkIcon,
  "migrationhub": MigrationHubIcon,
  "mobileanalytics": MobileAnalyticsIcon,
  "mobilehub": MobileHubIcon,
  "opsworks": OpsWorksIcon,
  "organizations": OrganizationsIcon,
  "pinpoint": PinpointIcon,
  "polly": PollyIcon,
  "rekognition": RekognitionIcon,
  "shield": ShieldIcon,
  "sms": SMSIcon,
  "snowball": SnowballIcon,
  "swf": SWFIcon,
  "trustedadvisor": TrustedAdvisorIcon,
  
  // Additional services that don't have specific icons - use default AWS icon
  "apigatewayv2": DefaultAWSIcon,
  "amplify": DefaultAWSIcon,
  "apprunner": DefaultAWSIcon,
  "appconfig": DefaultAWSIcon,
  "appflow": DefaultAWSIcon,
  "app-integrations": DefaultAWSIcon,
  "appmesh": DefaultAWSIcon,
  "appsync": DefaultAWSIcon,
  "route53-recovery-control": DefaultAWSIcon,
  "auditmanager": DefaultAWSIcon,
  "acm-pca": DefaultAWSIcon,
  "cloud9": DefaultAWSIcon,
  "logs": DefaultAWSIcon,
  "rum": DefaultAWSIcon,
  "synthetics": DefaultAWSIcon,
  "evidently": DefaultAWSIcon,
  "codeartifact": DefaultAWSIcon,
  "codeguru-reviewer": DefaultAWSIcon,
  "codeguru-profiler": DefaultAWSIcon,
  "comprehend": DefaultAWSIcon,
  "databrew": DefaultAWSIcon,
  "datasync": DefaultAWSIcon,
  "ecr-public": DefaultAWSIcon,
  "emr-serverless": DefaultAWSIcon,
  "emr-eks": DefaultAWSIcon,
  "opensearch": DefaultAWSIcon,
  "fsx": DefaultAWSIcon,
  "finspace": DefaultAWSIcon,
  "groundstation": DefaultAWSIcon,
  "healthlake": DefaultAWSIcon,
  "omics": DefaultAWSIcon,
  "access-analyzer": DefaultAWSIcon,
  "ivschat": DefaultAWSIcon,
  "imagebuilder": DefaultAWSIcon,
  "kendra": DefaultAWSIcon,
  "kinesisanalytics": DefaultAWSIcon,
  "kinesisvideo": DefaultAWSIcon,
  "location": DefaultAWSIcon,
  "lookoutmetrics": DefaultAWSIcon,
  "lookoutvision": DefaultAWSIcon,
  "mq": DefaultAWSIcon,
  "m2": DefaultAWSIcon,
  "managedgrafana": DefaultAWSIcon,
  "msk": DefaultAWSIcon,
  "migration-hub-refactor-spaces": DefaultAWSIcon,
  "mobiletargeting": DefaultAWSIcon,
  "network-firewall": DefaultAWSIcon,
  "networkmanager": DefaultAWSIcon,
  "panorama": DefaultAWSIcon,
  "personalize": DefaultAWSIcon,
  "proton": DefaultAWSIcon,
  "qldb": DefaultAWSIcon,
  "ram": DefaultAWSIcon,
  "resource-groups": DefaultAWSIcon,
  "resource-explorer-2": DefaultAWSIcon,
  "route53resolver": DefaultAWSIcon,
  "route53-recovery-readiness": DefaultAWSIcon,
  "sagemaker": DefaultAWSIcon,
  "signer": DefaultAWSIcon,
  "transfer": DefaultAWSIcon,
  "workspaces": DefaultAWSIcon,
};

// Helper function to get icon for a service name
const getServiceIcon = (serviceName) => {
  const icon = resourceIconMap[serviceName];
  if (!icon) {
    return DefaultAWSIcon;
  }
  
  // Check if it's a React component (from react-aws-icons)
  // React components are functions, and react-aws-icons components are functions
  if (typeof icon === 'function') {
    return icon;
  }
  
  // Return the icon (PNG or SVG)
  return icon;
};

// Helper function to format service name for display
const formatServiceName = (serviceName) => {
  // Handle special cases
  if (serviceName === "resource-explorer-2") return "Resource Explorer";
  
  // Convert kebab-case to Title Case
  return serviceName
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
    .replace(/\b\w/g, l => l.toUpperCase()); // Capitalize first letter of each word
};

const AssetManagementInfoCard = ({ metricObject }) => {
  // Convert metricObject to an array of objects for rendering and sort by asset name
  const assets = Object.keys(metricObject)
    .map((resourceName) => {
      const icon = getServiceIcon(resourceName);
      const isReactComponent = typeof icon === 'function';
      
      return {
        icon: icon,
        isReactComponent: isReactComponent,
        asset: formatServiceName(resourceName),
        value: metricObject[resourceName],
      };
    })
    .sort((a, b) => a.asset.localeCompare(b.asset)); // Sort assets alphabetically

  return (
    <Box sx={{ padding: "16px", backgroundColor: "background.paper", borderRadius: "8px", boxShadow: 3 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr", // Single column layout for each asset row
          gap: "8px",
        }}
      >
        {assets.map((row, index) => (
          <Box
            key={index}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              padding: "8px",
              borderRadius: "8px",
              backgroundColor: "grey.100",
            }}
          >
            <Box display="flex" alignItems="center">
              <Box sx={{ marginRight: "8px" }}>
                {row.isReactComponent ? (
                  React.createElement(row.icon, { width: 24, height: 24 })
                ) : (
                  <img
                    src={row.icon}
                    width="24px"
                    height="24px"
                    alt={row.asset}
                    style={{ objectFit: "contain" }}
                  />
                )}
              </Box>
              <Typography variant="body2">
                {row.asset}
              </Typography>
            </Box>
            <Typography variant="body2" align="right">
              {row.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AssetManagementInfoCard;
